import type { FormEvent } from "react";

import { Button, ButtonTypes } from "../basic/button";
import { Loading } from "../basic/loading";
import TextBox from "../basic/textBox";
import { LoginBackground } from "./background";

interface Props {
	password: string;
	setPassword: (value: string) => void;
	submitFunction: (event: FormEvent<HTMLFormElement>) => void;
	goBack?: () => void;
	loading: boolean;
	disabled: boolean;
	version?: string;
	error?: string;

	appLogo?: string;
	backgroundImage?: string;
}

export function ResetPasswordPage(props: Props) {
	const {
		password,
		setPassword,
		submitFunction,
		goBack,
		loading,
		disabled,
		version,
		error,
		appLogo,
		backgroundImage,
	} = props;

	return (
		<LoginBackground
			title="Reset Password"
			description="You must reset your password to continue. Enter a new password below."
			version={version}
			appLogo={appLogo}
			backgroundImage={backgroundImage}
		>
			<form className="grid gap-4" onSubmit={submitFunction}>
				<TextBox
					id="password"
					name="password"
					label="Password"
					value={password}
					changeHandler={setPassword}
					type="password"
					className="!m-0"
					disabled={disabled}
				/>
				{error !== undefined && <span className="text-sm text-red-400">{error}</span>}
				<Loading loading={loading} message="Logging in...">
					<Button type="submit" className="w-full" types={[ButtonTypes.Primary]} disabled={disabled}>
						Reset
					</Button>
				</Loading>
				{goBack && (
					<Button className="w-full" types={[ButtonTypes.Outline]} onClick={goBack}>
						Go Back
					</Button>
				)}
			</form>
		</LoginBackground>
	);
}
